var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Pause component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconPause extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.60547 3.41526C2.60547 2.96749 2.96846 2.60449 3.41624 2.60449H7.31816C7.76594 2.60449 8.12893 2.96749 8.12893 3.41526V20.5837C8.12893 21.0315 7.76594 21.3945 7.31816 21.3945H3.41624C2.96846 21.3945 2.60547 21.0315 2.60547 20.5837V3.41526ZM3.41624 1.10449C2.14004 1.10449 1.10547 2.13906 1.10547 3.41526V20.5837C1.10547 21.8599 2.14004 22.8945 3.41624 22.8945H7.31816C8.59436 22.8945 9.62893 21.8599 9.62893 20.5837V3.41526C9.62893 2.13906 8.59436 1.10449 7.31816 1.10449H3.41624ZM15.8721 3.41526C15.8721 2.96749 16.2351 2.60449 16.6828 2.60449H20.5848C21.0325 2.60449 21.3955 2.96749 21.3955 3.41526V20.5837C21.3955 21.0315 21.0325 21.3945 20.5848 21.3945H16.6828C16.2351 21.3945 15.8721 21.0315 15.8721 20.5837V3.41526ZM16.6828 1.10449C15.4066 1.10449 14.3721 2.13906 14.3721 3.41526V20.5837C14.3721 21.8599 15.4066 22.8945 16.6828 22.8945H20.5848C21.861 22.8945 22.8955 21.8599 22.8955 20.5837V3.41526C22.8955 2.13906 21.861 1.10449 20.5848 1.10449H16.6828Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconPause.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconPause.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconPause.prototype, "size", void 0);
if (customElements.get('cat-icon-pause') === undefined) {
    customElements.define('cat-icon-pause', BlocksIconPause);
}
